/* ===========================================================================
   Aboreo — capa de movimiento (complementa assets/aboreo-reveal.js)
   ---------------------------------------------------------------------------
   Sin dependencias. Todo va dentro de try/catch implícito: si un elemento no
   existe en la página, ese bloque simplemente no hace nada.
   Respeta "reducir movimiento" del sistema en todos los efectos.
   =========================================================================== */
(function () {
  'use strict';
  if (typeof window === 'undefined' || !document.querySelector) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var coarsePointer = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* -------------------------------------------------------------------------
     2. La figura vuela al carrito
     ------------------------------------------------------------------------- */
  function cartTarget() {
    var candidates = ['.aboreo-header__cart-count', '.aboreo-header__cart'];
    for (var i = 0; i < candidates.length; i++) {
      var el = $(candidates[i]);
      if (el && el.offsetParent !== null) return el;
    }
    return $('.aboreo-header__cart');
  }

  function popCartCount() {
    var count = $('.aboreo-header__cart-count');
    if (!count) return;
    count.classList.remove('is-pulsing');
    void count.offsetWidth;
    count.classList.add('is-pulsing');
  }

  function flyToCart(sourceImg) {
    if (reduce || !sourceImg || typeof sourceImg.animate !== 'function') { popCartCount(); return; }
    var target = cartTarget();
    if (!target) return;

    var from = sourceImg.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var size = Math.max(46, Math.min(96, from.width * 0.42));
    var flyer = document.createElement('div');
    flyer.className = 'aboreo-flyer';
    flyer.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    flyer.style.top = (from.top + from.height / 2 - size / 2) + 'px';
    flyer.style.width = size + 'px';
    flyer.style.height = size + 'px';

    var img = document.createElement('img');
    img.src = sourceImg.currentSrc || sourceImg.src;
    img.alt = '';
    flyer.appendChild(img);
    document.body.appendChild(flyer);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    var anim = flyer.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.55) + 'px, ' + (dy - 90) + 'px) scale(.6)', opacity: .95, offset: .55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.12)', opacity: .15 }
    ], { duration: 680, easing: 'cubic-bezier(.4, 0, .2, 1)' });

    function done() {
      if (flyer.parentNode) flyer.parentNode.removeChild(flyer);
      popCartCount();
    }
    if (anim.finished && anim.finished.then) anim.finished.then(done).catch(done);
    else anim.onfinish = done;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var quickAdd = e.target.closest('[data-aboreo-quick-add]');
    if (quickAdd) {
      if (quickAdd.disabled) return;
      var card = quickAdd.closest('.aboreo-card');
      flyToCart(card && (card.querySelector('.aboreo-card__img--front') || card.querySelector('.aboreo-card__img')));
      return;
    }

    var buy = e.target.closest('.aboreo-product__buy');
    if (buy && !buy.disabled) {
      flyToCart($('.aboreo-product__zoom img') || $('.aboreo-product__media img'));
    }
  }, true);

  /* -------------------------------------------------------------------------
     3. Chispas al guardar en favoritos (solo al marcar, no al quitar)
     ------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (reduce || !e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn || typeof btn.animate !== 'function') return;

    window.setTimeout(function () {
      if (!btn.classList.contains('is-active')) return;
      var r = btn.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;

      for (var i = 0; i < 8; i++) {
        (function (i) {
          var s = document.createElement('span');
          s.className = 'aboreo-spark';
          s.style.left = (cx - 3) + 'px';
          s.style.top = (cy - 3) + 'px';
          document.body.appendChild(s);

          var angle = (Math.PI * 2 * i) / 8 + Math.random() * 0.5;
          var dist = 26 + Math.random() * 20;
          var a = s.animate([
            { transform: 'translate(0, 0) scale(1)', opacity: 1 },
            { transform: 'translate(' + (Math.cos(angle) * dist) + 'px, ' + (Math.sin(angle) * dist) + 'px) scale(0)', opacity: 0 }
          ], { duration: 460 + Math.random() * 220, easing: 'cubic-bezier(.16, 1, .3, 1)' });

          function kill() { if (s.parentNode) s.parentNode.removeChild(s); }
          if (a.finished && a.finished.then) a.finished.then(kill).catch(kill);
          else a.onfinish = kill;
        })(i);
      }
    }, 40);
  });

  /* -------------------------------------------------------------------------
     4. Segunda foto en celular: un vistazo al entrar en pantalla
     ------------------------------------------------------------------------- */
  if (coarsePointer && !reduce && 'IntersectionObserver' in window) {
    var peekCards = $$('.aboreo-card__media').filter(function (m) {
      return m.querySelector('.aboreo-card__img--back');
    });
    if (peekCards.length) {
      var photoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var media = entry.target;
          photoIO.unobserve(media);
          window.setTimeout(function () {
            media.classList.add('is-peeking');
            window.setTimeout(function () { media.classList.remove('is-peeking'); }, 1100);
          }, 350);
        });
      }, { threshold: 0.55 });
      peekCards.forEach(function (m) { photoIO.observe(m); });
    }
  }

  /* -------------------------------------------------------------------------
     6. Títulos con máscara: cada palabra dentro de su propia ventana
     aboreo-reveal.js ya partió el título en .aboreo-reveal-word; aquí solo se
     envuelve cada palabra para poder recortarla.
     ------------------------------------------------------------------------- */
  function wrapWords() {
    $$('.aboreo-reveal-words .aboreo-reveal-word').forEach(function (word) {
      var parent = word.parentNode;
      if (parent && parent.classList && parent.classList.contains('aboreo-word-mask')) return;
      var mask = document.createElement('span');
      mask.className = 'aboreo-word-mask';
      parent.insertBefore(mask, word);
      mask.appendChild(word);
    });
  }
  wrapWords();
  window.setTimeout(wrapWords, 300);

  /* -------------------------------------------------------------------------
     8. El carrusel de categorías se asoma al entrar en pantalla
     ------------------------------------------------------------------------- */
  var track = $('.aboreo-categorias__track');
  if (track && !reduce && 'IntersectionObserver' in window) {
    var peekIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        peekIO.disconnect();
        if (track.scrollWidth > track.clientWidth + 24) track.classList.add('aboreo-peek');
      });
    }, { threshold: 0.35 });
    peekIO.observe(track);
  }

  /* -------------------------------------------------------------------------
     9. Hero con profundidad: fondo, figura y texto a distinta velocidad
     ------------------------------------------------------------------------- */
  var hero = $('.aboreo-hero');
  if (hero && finePointer && !reduce) {
    var heroBg = $('.aboreo-hero__bg', hero);
    var heroContent = $('.aboreo-hero__content', hero);
    var heroTicking = false;
    var heroX = 0, heroY = 0;

    hero.addEventListener('pointermove', function (e) {
      var rect = hero.getBoundingClientRect();
      heroX = (e.clientX - rect.left) / rect.width - 0.5;
      heroY = (e.clientY - rect.top) / rect.height - 0.5;
      if (heroTicking) return;
      heroTicking = true;
      window.requestAnimationFrame(function () {
        if (heroBg) heroBg.style.translate = (-heroX * 20) + 'px ' + (-heroY * 14) + 'px';
        if (heroContent) heroContent.style.translate = (heroX * 11) + 'px ' + (heroY * 7) + 'px';
        heroTicking = false;
      });
    }, { passive: true });

    hero.addEventListener('pointerleave', function () {
      if (heroBg) heroBg.style.translate = '0px 0px';
      if (heroContent) heroContent.style.translate = '0px 0px';
    });
  }

  /* -------------------------------------------------------------------------
     11. El ticker responde al scroll: acelera bajando, se frena subiendo
     ------------------------------------------------------------------------- */
  var tickerTrack = $('.aboreo-ticker__track');
  var ticker = $('.aboreo-ticker');
  if (tickerTrack && ticker && !reduce) {
    tickerTrack.classList.add('aboreo-ticker--js');

    var seconds = parseFloat(getComputedStyle(ticker).getPropertyValue('--ticker-speed')) || 24;
    var halfWidth = 0;
    var pos = 0;
    var extra = 0;
    var lastY = window.pageYOffset;
    var onScreen = true;
    var running = false;

    function measure() { halfWidth = tickerTrack.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure, { passive: true });

    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      var delta = y - lastY;
      lastY = y;
      extra = Math.max(-9, Math.min(9, delta * 0.3));
    }, { passive: true });

    function step() {
      if (!onScreen || document.hidden) { running = false; return; }
      var base = halfWidth ? halfWidth / (seconds * 60) : 0.6;
      pos -= base + extra;
      extra *= 0.92;
      if (halfWidth) {
        if (pos <= -halfWidth) pos += halfWidth;
        if (pos > 0) pos -= halfWidth;
      }
      tickerTrack.style.transform = 'translateX(' + pos + 'px)';
      window.requestAnimationFrame(step);
    }
    function start() {
      if (running) return;
      running = true;
      window.requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          onScreen = entry.isIntersecting;
          if (onScreen) start();
        });
      }, { rootMargin: '80px 0px' }).observe(ticker);
    } else {
      onScreen = true;
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    start();
  }

  /* -------------------------------------------------------------------------
     12. La figura crece del catálogo hacia su ficha (View Transitions)
     El nombre debe ser único en la página: se limpia antes de asignarlo, y al
     volver con el botón atrás.
     ------------------------------------------------------------------------- */
  function clearTransitionNames() {
    $$('.aboreo-card__img').forEach(function (img) { img.style.viewTransitionName = ''; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('.aboreo-card__link');
    if (!link) return;
    var card = link.closest('.aboreo-card');
    if (!card) return;
    var img = card.querySelector('.aboreo-card__img--front') || card.querySelector('.aboreo-card__img');
    if (!img) return;
    clearTransitionNames();
    img.style.viewTransitionName = 'aboreo-figura';
  }, true);

  window.addEventListener('pageshow', clearTransitionNames);

  var productImage = $('.aboreo-product__zoom img') || $('.aboreo-product__media img');
  if (productImage) productImage.style.viewTransitionName = 'aboreo-figura';
})();
